import { inject, Injectable } from '@angular/core';
import { ENV_CONFIG, EnvConfig } from '../env';

@Injectable({
  providedIn: 'root'
})
export class DeepLinkService {
  private readonly env: EnvConfig = inject(ENV_CONFIG);

  generateWebLink(path: string): string {
    return `${this.env.frontendUrl}/${path}`;
  }
}
